import { useState, useEffect } from 'react';

function useGoogleTranslateLanguage() {
  // Helper to read the googtrans cookie.
  const getLanguageFromCookie = () => {
    const match = document.cookie.match(/googtrans=\/[^\/]+\/([^;]+)/);
    // If cookie indicates Spanish, return 'es'; otherwise, assume 'en'
    return match && match[1] === 'es' ? 'es' : 'en';
  };

  const [lang, setLang] = useState(getLanguageFromCookie());

  useEffect(() => {
    // Poll every 500 ms to detect a change in the googtrans cookie.
    const interval = setInterval(() => {
      const currentLang = getLanguageFromCookie();
      if (currentLang !== lang) {
        setLang(currentLang);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [lang]);

  return lang;
}

export default useGoogleTranslateLanguage;
